import { useMemo } from 'react';
import { usePagination } from '@mantine/hooks';

import PaginationComponent from '~/domains/design-system/components/Table/PaginationComponent';

import useStyles from './styles';

type LobbyPaginationProps = {
  page: number;
  pages: number;
  limit: number;
  itemsTotal: number;
  setLimit: (limit: number) => void;
  handlePageChange: (page: number) => void;
};

function LobbyPagination({
  page,
  pages,
  limit,
  itemsTotal,
  setLimit,
  handlePageChange,
}: LobbyPaginationProps) {
  const { classes } = useStyles();
  const { next, previous, first } = usePagination({
    total: pages,
    page,
    onChange: handlePageChange,
  });

  const handleLimitChange = (value: string) => {
    first();
    setLimit(parseInt(value, 10));
  };

  const pageSizes = ['10', '25', '50'];

  return (
    <PaginationComponent
      className={classes.pagination}
      total={itemsTotal}
      offset={(page - 1)* limit}
      limit={limit}
      pageSizes={pageSizes}
      unit="contests"
      handlePrevPage={previous}
      handleNextPage={next}
      handleLimitChange={handleLimitChange}
    />
  );
}

export default LobbyPagination;
